module.exports = __webpack_public_path__ + "static/media/share-link.d86a127e.svg";